export const throwUnsupportedProvider = (_: never): never => {
  throw Error(`Unsupported provider`);
};
